import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import { InputField } from '@unite-us/app-components';
import AddressFieldConditionalDisplay from './AddressFieldConditionalDisplay';
import { DISPLAY_CITY_STATE, DISPLAY_FULL } from '../constants';

const getFieldError = (meta) => (meta.touched && meta.error ? meta.error : undefined);

const required = (value) => (value ? undefined : 'Required');

const getEventValue = (e) => (e?.target ? e.target.value : e);

function AddressStreetFields({
  addressId,
  displayFieldSet,
  fieldPrefix,
  inline,
  inputStyle,
  labelStyle,
  onFieldChange,
}) {
  return (
    <div className="row">
      <div className="col-xs-12">
        <AddressFieldConditionalDisplay selectedFieldSet={displayFieldSet} validDisplayTypes={DISPLAY_FULL}>
          <Field name={`${fieldPrefix}.line_1`} validate={required}>
            {({ input, meta }) => (
              <InputField
                id={`${addressId}-line1`}
                inline={inline}
                inputStyle={inputStyle}
                label="Address Line 1"
                labelStyle={labelStyle}
                value={input.value}
                onChange={(e) => onFieldChange('line_1', getEventValue(e), input.onChange)}
                onBlur={input.onBlur}
                error={getFieldError(meta)}
                required
              />
            )}
          </Field>
        </AddressFieldConditionalDisplay>

        <AddressFieldConditionalDisplay selectedFieldSet={displayFieldSet} validDisplayTypes={DISPLAY_FULL}>
          <Field name={`${fieldPrefix}.line_2`}>
            {({ input, meta }) => (
              <InputField
                id={`${addressId}-line2`}
                inline={inline}
                inputStyle={inputStyle}
                label="Address Line 2"
                labelStyle={labelStyle}
                value={input.value}
                onChange={input.onChange}
                onBlur={input.onBlur}
                error={getFieldError(meta)}
              />
            )}
          </Field>
        </AddressFieldConditionalDisplay>

        <AddressFieldConditionalDisplay selectedFieldSet={displayFieldSet} validDisplayTypes={DISPLAY_CITY_STATE}>
          <Field name={`${fieldPrefix}.city`} validate={required}>
            {({ input, meta }) => (
              <InputField
                id={`${addressId}-city`}
                inline={inline}
                inputStyle={inputStyle}
                label="City"
                labelStyle={labelStyle}
                placeholder="City"
                value={input.value}
                onChange={(e) => onFieldChange('city', getEventValue(e), input.onChange)}
                onBlur={input.onBlur}
                error={getFieldError(meta)}
                required
              />
            )}
          </Field>
        </AddressFieldConditionalDisplay>
      </div>
    </div>
  );
}

AddressStreetFields.propTypes = {
  addressId: PropTypes.string.isRequired,
  displayFieldSet: PropTypes.string.isRequired,
  fieldPrefix: PropTypes.string.isRequired,
  inline: PropTypes.bool.isRequired,
  inputStyle: PropTypes.object.isRequired,
  labelStyle: PropTypes.object.isRequired,
  onFieldChange: PropTypes.func.isRequired,
};

export default AddressStreetFields;
